async function buildPaymentCalculationUrl(modifiedConfig, listing) {
  let dealerSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let vehicleType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Used';
  const {
    dealerZip,
    ecommerce = '',
    msrp,
    dealerId,
    // number - 8084
    partnerId,
    // string - MMD
    listingPrice,
    disableIncentives,
    chromeStyleId: styleId = null,
    // Need to clean it up once ddc moved this to listing
    shopperZip,
    supportedDealTypes,
    showRatesTable,
    boaDealerID,
    // number - 4016303902 - BOA specific dealer ID
    includeDealerAndLenderFees
  } = modifiedConfig;
  const {
    mileage = 0,
    vin = '',
    chromeStyleId = null
  } = listing;
  const isNewCar = vehicleType === 'New';
  const {
    incentives: {
      excludeSpecialAPRLeaseOffersNewCar = false,
      excludeSpecialAPRLoanOffersNewCar = false,
      excludeSpecialAPRLoanOffersUsedCar = false,
      enableMaxCashIncentives = false
    } = {},
    excludeStdCashIncsCash = false,
    excludeStdCashIncsLease = false,
    excludeStdCashIncsLoan = false,
    leasing = {},
    cash = {}
  } = dealerSettings || {};
  let query = {
    dealerZip: dealerZip || shopperZip,
    mileage,
    vin,
    certifiedUsed: listing.isCertified || false,
    listingType: vehicleType,
    styleId: chromeStyleId || styleId,
    excludeOfferLease: excludeStdCashIncsLease,
    excludeOfferLoan: excludeStdCashIncsLoan,
    excludeOfferCash: excludeStdCashIncsCash,
    cashPaymentBasedMsrp: cash?.calculateOnMSRP || false,
    leasePaymentBasedMsrp: leasing?.calculateOnMSRP || false,
    leaseDeductDueAtSigning: leasing?.isDueAtSigninAmountDeduct || false,
    msrp: msrp || listingPrice,
    salePrice: listingPrice,
    ...((dealerId || boaDealerID) && {
      dealerId: boaDealerID || dealerId
    }),
    ...(partnerId && {
      partnerId
    }),
    enableLease: !!supportedDealTypes?.includes('lease'),
    disableIncentives,
    ...(['Accelerate', 'BOA'].includes(ecommerce) && {
      enableMaxCashIncentives
    }),
    ...(showRatesTable && {
      quotePreference: 'All'
    }),
    ...(boaDealerID && {
      lenders: 'BOA'
    }),
    ...(includeDealerAndLenderFees && {
      includeDealerAndLenderFees
    })
  };
  if (isNewCar) {
    query = {
      ...query,
      excludeSpecialAprLease: excludeSpecialAPRLeaseOffersNewCar,
      excludeSpecialAprLoan: excludeSpecialAPRLoanOffersNewCar
    };
  } else {
    query = {
      ...query,
      excludeSpecialAprLoan: excludeSpecialAPRLoanOffersUsedCar
    };
  }
  const paymentCalcUrl = new URLSearchParams(query).toString();
  return paymentCalcUrl || '';
}
export { buildPaymentCalculationUrl as default };
